<header>
  <div class="row justify-content-md-center m-0">
    <div class="col-md-12" style="max-width: 1060px;">

      <ul class="navbar-nav">
        <!--<li class="nav-item icon">
    <button class="hamburger" id="hamburger-btn">
      <span class="material-icons">menu</span>
    </button>
  </li>-->
        <li class="nav-item">
          <img src="assets/images/unisource-logo.png" class="logo" alt="" />
        </li>

        <li class="flex-fill">
        </li>

        <li class="nav-item">
          <div class="user-name-container">
            <i class="material-icons">account_circle</i>
            <span class="user-name-text">{{userName}}</span>
          </div>
        </li>
        <li class="nav-item">
          <button type="button" id="closeAppBtn" class="btn btn-primary" (click)="closeInteraction()" style="height: auto; margin-top: 11px;"><span class="material-icons">close</span> Close</button>
        </li>
        <!--<li class="nav-item icon">
    <span *ngIf="isDevMode" class="environment-label">Development</span>
  </li>-->
        <!-- Messages Dropdown Menu -->
        <!--<li class="nav-item dropdown with-caret">
    <a class="nav-link" data-toggle="dropdown" href="#">
      <div class="avatar avatar-sm avatar-dnd bg-primary">
        <img src="assets/images/user.png" class="avatar-img align-top rounded-circle" alt="" />
      </div>
    </a>
    <div class="dropdown-menu p-1 dropdown-menu-right">
      <span class="dropdown-item">
        Welcome, Jhon
      </span>
    </div>
  </li>-->
      </ul>

    </div>
  </div>

</header>
